import { createFileRoute, Navigate } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { FoodSessionId, FoodSessionStatusEnum } from "@brewbase/db/types";

const DEFAULT_SECTION_BY_STATUS: Record<FoodSessionStatusEnum, string> = {
  [FoodSessionStatusEnum.unstarted]: "/food-app/sessions/$session_id/general",
  [FoodSessionStatusEnum.in_progress]: "/food-app/sessions/$session_id/running",
  [FoodSessionStatusEnum.review]: "/food-app/sessions/$session_id/analysis",
  [FoodSessionStatusEnum.completed]: "/food-app/sessions/$session_id/results",
};

export const Route = createFileRoute("/food-app/sessions/$session_id/")({
  component: IndexRedirect,
});

function IndexRedirect() {
  const { session_id } = Route.useParams();
  const { data: session } = trpc.food.sessions.get.useQuery(session_id as FoodSessionId);

  const status = session?.status ?? FoodSessionStatusEnum.unstarted;
  const to = DEFAULT_SECTION_BY_STATUS[status];

  return (
    <Navigate
      to={to}
      params={{ session_id }}
      replace
    />
  );
}
